<template>
    <customModal :containerxl="true" :bodyxl="true" :footerShow="true" @closeModal="closeModal">
        <template #title>
            <h4 class="my-0">{{ isEditMode ? 'Edit Mitigation Plan' : 'Add Mitigation Plan' }}</h4>
        </template>

        <template #body>
            <form>
                <div class="row">                    
                    <!-- Section 1: IDs & References -->
                    <div class="col-12 mb-2">
                        <h6 class="border-bottom py-1">References & Identifiers</h6>
                    </div>

                    <div class="col-lg-4 mb-2">
                        <label class="form-label mb-0">Mitigation ID <sup ><i class="fa fa-asterisk required"></i></sup></label>
                        <input type="text" class="form-control" v-model="values.mitigationId"
                            :class="{ 'errorClass': errors.mitigationId }"
                            :disabled="isEditMode"
                            @input="errors.mitigationId = ''" />
                        <div class="errorClass" v-if="errors.mitigationId">{{ errors.mitigationId }}</div>
                    </div>

                    <div class="col-lg-4 mb-2">
                        <label class="form-label mb-0">KRI ID</label>
                        <input type="text" class="form-control" v-model="values.kriId"/>
                    </div>

                    <div class="col-lg-4 mb-2">
                        <label class="form-label mb-0">Risk ID</label>
                        <input type="text" class="form-control" v-model="values.riskId" :disabled="ctqFieldsLocked" />
                    </div>

                    <div class="col-lg-4 mb-2">
                        <label class="form-label mb-0">CTQ ID</label>
                        <input type="text" class="form-control" v-model="values.ctqId" :disabled="ctqFieldsLocked" />
                    </div>

                    <div class="col-lg-8 mb-2">
                        <label class="form-label mb-0">CTQ Factor</label>
                        <input type="text" class="form-control" v-model="values.ctqFactor" :disabled="ctqFieldsLocked" />
                    </div>

                    <!-- Section 2: Parameters & Progress -->
                    <div class="col-12 mt-3 mb-2">
                        <h6 class="border-bottom py-1">Parameters & Progress</h6>
                    </div>

                    <div class="col-lg-4 mb-2">
                        <label class="form-label mb-0">Monitoring Frequency</label>
                        <input type="text" class="form-control" v-model="values.monitoringFrequency" />
                    </div>

                    <div class="col-lg-4 mb-2">
                        <label class="form-label mb-0">Action Owner</label>
                        <input type="text" class="form-control" v-model="values.actionOwner" />
                    </div>

                    <div class="col-lg-4 mb-2">
                        <label class="form-label mb-0">Target Completion Date</label>
                        <input type="date" class="form-control" v-model="values.targetCompletionDate" />
                    </div>

                    <div class="col-lg-4 mt-2 d-flex align-items-center">
                        <div>
                            <input type="checkbox" id="isActiveCheck" v-model="values.isActive">
                            <label class="form-check-label ms-2" for="isActiveCheck">Is Active</label>
                        </div>
                    </div>

                    <!-- Section 3: Narrative Textareas -->
                    <div class="col-12 mt-3 mb-2">
                        <h6 class="border-bottom py-1">Narratives & Strategy</h6>
                    </div>

                    <div class="col-lg-6 mb-2">
                        <label class="form-label mb-0">Risk Description <sup ><i class="fa fa-asterisk required"></i></sup></label>
                        <textarea rows="3" class="form-control custom-textarea"
                            :class="{ 'errorClass': errors.riskDescription }"
                            v-model="values.riskDescription"
                            @input="errors.riskDescription = ''" />
                        <div class="errorClass" v-if="errors.riskDescription">{{ errors.riskDescription }}</div>
                    </div>

                    <div class="col-lg-6 mb-2">
                        <label class="form-label mb-0">Mitigation Strategy <sup ><i class="fa fa-asterisk required"></i></sup></label>
                        <textarea rows="3" class="form-control custom-textarea"
                            :class="{ 'errorClass': errors.mitigationStrategy }"
                            v-model="values.mitigationStrategy"
                            @input="errors.mitigationStrategy = ''" />
                        <div class="errorClass" v-if="errors.mitigationStrategy">{{ errors.mitigationStrategy }}</div>
                    </div>

                    <div class="col-lg-6 mb-2">
                        <label class="form-label mb-0">Contingency Plan</label>
                        <textarea rows="3" class="form-control custom-textarea" v-model="values.contingencyPlan" />
                    </div>

                    <div class="col-lg-6 mb-2">
                        <label class="form-label mb-0">Evidence of Implementation</label>
                        <textarea rows="3" class="form-control custom-textarea" v-model="values.evidenceOfImplementation" />
                    </div>

                </div>
            </form>
        </template>

        <template #footer>
            <div class="d-flex justify-content-end align-items-center">
                <div v-if="submitting" class="spinner-border text-primary spinner-border-sm me-3" role="status">
                    <span class="visually-hidden">Saving...</span>
                </div>
                <button class="cancel_btn py-1 px-4 mx-2" :disabled="submitting" @click.prevent="clear">
                    Clear
                </button>
                <button class="save_btn py-1 px-4" :disabled="submitting" @click.prevent="saveClicked">
                    Save
                </button>
            </div>
        </template>
    </customModal>
</template>

<script src="./ManageMitigationModal.js"></script>

<style scoped>
.section-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0;
}
.custom-textarea {
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 8px;
    resize: vertical;
}

</style>